<!-- Topbar -->
<!-- <nav style="background-color: #faad14;" class="navbar navbar-expand navbar-light topbar static-top shadow"
  [ngClass]="{'mb-4': router.url != '/home-enterprise/main' && router.url.indexOf('add-document') < 0 && router.url.indexOf('view-document') < 0 && router.url.indexOf('update-document') < 0}"> -->

<!-- <nav style="background: transparent linear-gradient(90deg, #04615e 0%, #11B7A4 60%, #0FDBAC 100%) 0% 0% no-repeat padding-box; z-index: 9999;" class="navbar navbar-expand navbar-light topbar static-top shadow sticky-top">-->
<!--  &lt;!&ndash; LOGO &ndash;&gt;-->
<!--  <a class="sidebar-brand d-flex align-items-center justify-content-center ml-2" href="/home-enterprise">-->
<!--    <div>-->
<!--      <img class="logo-full" alt="Logo" src="../../../../../assets/images/logo_w.png">-->
<!--      &lt;!&ndash; <img class="logo-collapse" alt="Logo" src="../../../../../assets/images/logo_sw.png"> &ndash;&gt;-->
<!--    </div>-->
<!--  </a> -->

<!--  &lt;!&ndash; Page Heading &ndash;&gt;-->
<!--  &lt;!&ndash; <div class="d-sm-flex align-items-center justify-content-between"> &ndash;&gt;-->
<!--  &lt;!&ndash; breadcrumb &ndash;&gt;-->
<!--  &lt;!&ndash; <app-breadcrumbs>-->
<!--  </app-breadcrumbs>-->
<!--</div> &ndash;&gt;-->

<!--  &lt;!&ndash; Topbar Navbar &ndash;&gt;-->
<!--  <ul class="navbar-nav ml-auto">-->
<!--    &lt;!&ndash; Nav Item - Vietnamese &ndash;&gt;-->
<!--    <li class="nav-item no-arrow mx-1" (click)="activateClassLanguage('vi')" [ngClass]="{'active': langCurrent == 'vi'}">-->
<!--      <a class="nav-link vt-cursor-pointer vt-vietnamese-flag" (click)="onChangeLanguage('vi')"-->
<!--         [matTooltip]="'header.vietnamese' | translate"><img class="vt-cursor-pointer" src="./assets/images/vn.png"-->
<!--                                                             alt="vietnamese" width="30" height="20"></a>-->
<!--    </li>-->

<!--    &lt;!&ndash; Nav Item - English &ndash;&gt;-->
<!--    <li class="nav-item no-arrow mx-1" (click)="activateClassLanguage('en')" [ngClass]="{'active': langCurrent == 'en'}">-->
<!--      <a class="nav-link vt-cursor-pointer vt-english-flag" (click)="onChangeLanguage('en')"-->
<!--         [matTooltip]="'header.english' | translate"><img class="vt-cursor-pointer"-->
<!--                                                          src="./assets/images/en.png" alt="english" width="30" height="20"></a>-->
<!--    </li>-->

<!--    <div class="topbar-divider d-none d-sm-block"></div>-->

<!--    &lt;!&ndash; Nav Item - Alerts &ndash;&gt;-->
<!--    <li class="nav-item dropdown no-arrow mx-1">-->
<!--      <app-notify-alert></app-notify-alert>-->
<!--    </li>-->

<!--    &lt;!&ndash; Nav Item - User Information &ndash;&gt;-->
<!--    <li class="nav-item dropdown no-arrow">-->
<!--      <a class="nav-link dropdown-toggle nav-icon" id="userDropdown" role="button" data-toggle="dropdown"-->
<!--         aria-haspopup="true" aria-expanded="false">-->
<!--        <i class="fa fa-user-circle-o vt-cursor-pointer" [matTooltip]="userName"></i>-->
<!--        &lt;!&ndash; User name &ndash;&gt;-->
<!--        <span class="pl-2 pr-2 user-name" [matTooltip]="userName">-->
<!--          {{userName}}-->
<!--        </span>-->
<!--      </a>-->
<!--      &lt;!&ndash; Dropdown - User Information &ndash;&gt;-->
<!--      <div class="dropdown-menu dropdown-menu-right shadow animated&#45;&#45;grow-in triangle-user" aria-labelledby="userDropdown">-->
<!--        <a class="dropdown-item" href="javascript:void(0)">-->
<!--          &lt;!&ndash; <em class="fa fa-info fa-sm fa-fw mr-2 text-gray-400 vt-cursor-pointer"></em> &ndash;&gt;-->
<!--          <i class="fa fa-info fa-sm fa-fw mr-2 vt-cursor-pointer"></i>-->
<!--          {{userName}}-->
<!--        </a>-->
<!--        <div class="dropdown-divider"></div>-->
<!--        <a class="dropdown-item" href="javascript:void(0)" (click)="changePassword()">-->
<!--          &lt;!&ndash; <em class="fa fa-lock fa-sm fa-fw mr-2 text-gray-400 vt-cursor-pointer"></em> &ndash;&gt;-->
<!--          <i class="fa fa-lock fa-sm fa-fw mr-2 vt-cursor-pointer"></i>-->
<!--          {{'header.change_password' | translate}}-->
<!--        </a>-->
<!--        <div class="dropdown-divider"></div>-->
<!--        <a class="dropdown-item" href="javascript:void(0)" (click)="logout()">-->
<!--          &lt;!&ndash; <em class="fa fa-sign-out fa-sm fa-fw mr-2 text-gray-400 vt-cursor-pointer"></em> &ndash;&gt;-->
<!--          <i class="fa fa-sign-out fa-sm fa-fw mr-2 vt-cursor-pointer"></i>-->
<!--          {{'header.logout' | translate}}-->
<!--        </a>-->
<!--      </div>-->
<!--    </li>-->

<!--  </ul>-->

<!--</nav>-->
<!-- End of Topbar -->


<nav [ngStyle]="{'padding': isShowToggleBar? '0.27rem 1rem' : '0rem 1rem'}"
  class="navbar navbar-expand-md navbar-dark bg-dark sticky-top topbar-scontract {{isNotAttestedUser ? 'background-scontract' : 'background-vcontract'}}">
  <!-- Logo -->
  <div *ngIf="isExpaned && !isShowToggleBar" class="coll" id="collapse"(click)="openMenu($event)">
   <img src="assets/images/arrowLeft.png">
  </div>
  <div *ngIf="!isExpaned && !isShowToggleBar" class="exp" id="expanded" (click)="openMenu($event)">
    <i  class="fa-2x fa fa-bars" aria-hidden="true"></i>
   </div>
   <div class="verticalLine" *ngIf="!isShowToggleBar">
    &nbsp;
  </div>
  <a class="sidebar-brand" href="/home-enterprise">
    <img class="logo-full" alt="Logo" [src]="srcLogo" [ngStyle]="{ 'height.px': isNotAttestedUser ? '57': '34'}">
    <img *ngIf="showSpecialLogo" class="logo-full" alt="Logo" src="assets/images/logo_colab_0102912566.png" [ngStyle]="{ 'height.px': isNotAttestedUser ? '50': '44'}" style="margin-left: 16px; margin-bottom: 3px;">
  </a>

  <!-- Toggler show only mobile -->
  <!-- <button class="navbar-toggler navbar-toggler-right collapsed" type="button" data-toggle="collapse"
    data-target="#collapsibleNavbar" aria-expanded="false">
    <span class="navbar-toggler-icon"></span>
  </button> -->
  <div id="toggleBar" class="navbar-toggler-bar" data-toggle="collapse" data-target="#collapsibleNavbar"
    aria-expanded="false">
    <div class="bar1"></div>
    <div class="bar2"></div>
    <div class="bar3"></div>
  </div>

  <div class="navbar-collapse collapse" id="collapsibleNavbar">
    <div class="mr-auto"></div>
    <ul class="navbar-nav" id="navbar-nav-one">
      <!-- dowload app mobile  -->
      <div class="nav-item no-arrow mx-1 dowload-app-mobile" (click)="showModalDowloadApp()" [matTooltip]="'header.dowload_app_mobile' | translate">
        <svg width="21" height="21" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M5.54171 0H14.4583C15.2011 0 15.8091 0.607429 15.8091 1.35086V5H14.8691V2.14229H5.13086V17.5H12V20H5.54171C4.79886 20 4.19086 19.392 4.19086 18.6486V1.35086C4.19086 0.607429 4.79886 0 5.54171 0ZM11.4263 0.973714H8.57371C8.48343 0.973714 8.41029 1.04686 8.41029 1.13771C8.41029 1.228 8.48343 1.30114 8.57371 1.30114H11.4263C11.5166 1.30114 11.5897 1.228 11.5897 1.13771C11.5897 1.04686 11.5166 0.973714 11.4263 0.973714ZM9.32457 18.6486C9.32457 19.0223 9.62686 19.3246 10 19.3246C10.3731 19.3246 10.6754 19.0223 10.6754 18.6486C10.6754 18.2749 10.3731 17.9731 10 17.9731C9.62686 17.9731 9.32457 18.2749 9.32457 18.6486Z" [attr.fill]="deviceService.isMobile() ? 'red' : 'white'"/>
          <path d="M15 7C14.5582 7 14.2001 7.38374 14.2001 7.85711V15.9813L12.3831 13.9122C12.1173 13.5865 11.6417 13.5315 11.252 13.8753C10.9299 14.1998 10.9145 14.7425 11.2176 15.0873L14.4172 18.7301C14.7331 19.09 15.2669 19.09 15.5828 18.7301L18.7824 15.0873C19.0855 14.7425 19.0701 14.1998 18.748 13.8753C18.4263 13.5506 17.9197 13.5671 17.6169 13.9122L15.7999 15.9813V7.85711C15.7999 7.38374 15.4418 7 15 7Z" [attr.fill]="deviceService.isMobile() ? 'red' : 'white'"/>
        </svg>
<!--        <a class="text-app">{{ "header.dowload_app_mobile" | translate }}</a>-->
      </div>
      <!-- Ngôn ngữ -->
      <li>
        <button class="select-language" [matMenuTriggerFor]="menu" (menuOpened)="isOpen = true" (menuClosed)="isOpen = false">
          <div>
            <img *ngIf="langCurrent == 'vi'" class="vt-cursor-pointer" src="./assets/images/vn.svg" alt="vietnamese" width="30" height="20">
            <img *ngIf="langCurrent == 'en'" class="vt-cursor-pointer" src="./assets/images/en.svg" alt="english" width="30" height="20">
            <img *ngIf="langCurrent == 'zh'" class="vt-cursor-pointer" src="./assets/images/china.svg" alt="china" width="30" height="20">
            <img *ngIf="langCurrent == 'es'" class="vt-cursor-pointer" src="./assets/images/es.svg" alt="spanish" width="30" height="20">
          </div>
          <span class="">{{getCurrentNameLanguage()}}</span>
          <div class="">
              <em *ngIf="isOpen" class="material-icons">keyboard_arrow_up</em>
              <em *ngIf="!isOpen" class="material-icons">keyboard_arrow_down</em>
          </div>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="onChangeLanguage('vi')" style="width: 140px;"
              [ngClass]="{'active-btn': langCurrent == 'vi'}">
              <img class="vt-cursor-pointer" src="./assets/images/vn.svg" alt="vietnamese" width="30" height="20">
              {{'Tiếng Việt' | translate}}
          </button>
          <button mat-menu-item (click)="onChangeLanguage('en')" style="width: 140px;"
              [ngClass]="{'active-btn': langCurrent == 'en'}">
              <img class="vt-cursor-pointer" src="./assets/images/en.svg" alt="english" width="30" height="20">
              {{'English' | translate}}
          </button>
          <button mat-menu-item (click)="onChangeLanguage('zh')" style="width: 140px;"
              [ngClass]="{'active-btn': langCurrent == 'zh'}">
              <img class="vt-cursor-pointer" src="./assets/images/china.svg" alt="china" width="30" height="20">
              {{'中国人' | translate}}
          </button>
          <button mat-menu-item (click)="onChangeLanguage('es')" style="width: 140px;"
              [ngClass]="{'active-btn': langCurrent == 'es'}">
              <img class="vt-cursor-pointer" src="./assets/images/es.svg" alt="spanish" width="30" height="20">
              {{'Español' | translate}}
          </button>
        </mat-menu>
      </li>
      <!-- <li class="nav-item no-arrow mx-1" (click)="activateClassLanguage('vi')"
        [ngClass]="{'active': langCurrent == 'vi'}">
        <a class="nav-link vt-cursor-pointer vt-vietnamese-flag" (click)="onChangeLanguage('vi')"
          [matTooltip]="'header.vietnamese' | translate"><img class="vt-cursor-pointer" src="./assets/images/vn.png"
            alt="vietnamese" width="30" height="20"></a>
      </li>

      <li class="nav-item no-arrow mx-1" (click)="activateClassLanguage('en')"
        [ngClass]="{'active': langCurrent == 'en'}">
        <a class="nav-link vt-cursor-pointer vt-english-flag" (click)="onChangeLanguage('en')"
          [matTooltip]="'header.english' | translate"><img class="vt-cursor-pointer" src="./assets/images/en.png"
            alt="english" width="30" height="20"></a>
      </li>

      <li class="nav-item no-arrow mx-1" (click)="activateClassLanguage('zh-Hans')"
        [ngClass]="{'active': langCurrent == 'zh-Hans'}">
        <a class="nav-link vt-cursor-pointer vt-english-flag" (click)="onChangeLanguage('zh-Hans')"
          [matTooltip]="'header.english' | translate"><img class="vt-cursor-pointer" src="./assets/images/china.svg"
            alt="english" width="30" height="20"></a>
      </li> -->

      <div class="topbar-divider d-none d-sm-block"></div>

      <!-- Processing -->

      <li class="nav-item dropdown no-arrow mx-1"
        *ngIf="userType == userEnterpriseAdminType || userType == userEnterpriseStaffType">
        <app-processing></app-processing>
      </li>

      <!-- Alerts -->
      <li class="nav-item dropdown no-arrow mx-1">
        <app-notify-alert [notifies]="notifies" [totalUnread]="totalUnread" (notification)="updateNotification($event)">
        </app-notify-alert>
      </li>

      <!-- Help -->
      <li class="nav-item no-arrow mx-1">
        <app-mark-down></app-mark-down>
      </li>

      <!-- User Information -->
      <li id="user_information_dsk" class="nav-item dropdown no-arrow mx-1">
        <a class="nav-link dropdown-toggle nav-icon" id="userDropdown" role="button" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false" (click)="setShowChangeToDefault()">
          <div class="user-dropdown">
            <div class="icon-user mr-2">
              <i class="fa fa-user-circle-o vt-cursor-pointer" [matTooltip]="fullName"></i>
            </div>
            <div class="user-infomation">
              <!-- fullName -->
              <p class="full-name">{{fullName}}</p>
              <p>{{ isNotAttestedUser ? 'sContract' : 'vContract' }}</p>
            </div>
          </div>
          <!-- <i class="fa fa-user-circle-o vt-cursor-pointer" [matTooltip]="fullName"></i>
          <span class="pl-2 pr-2 user-name" [matTooltip]="fullName">
            {{fullName}}
          </span> -->
        </a>
        <!-- Dropdown - User Information -->
        <div id="header-dropdown-menu" class="dropdown-menu dropdown-menu-right shadow animated--grow-in triangle-user"
          aria-labelledby="userDropdown">
          <div [ngStyle]="{ 'display': !showChangeVersion ? 'block': 'none'}">
            <div class="dropdown-item-user">
              <div class="icon-user mr-2">
                <i class="fa fa-user-circle-o vt-cursor-pointer" [matTooltip]="userName"></i>
              </div>
              <div class="user-infomation">
                <p class="user-name">{{userName}}</p>
                <p *ngIf="connected2TypesAccounts" class="change-mode" (click)="swapMenu()">{{'header.choose_version' |
                  translate}}</p>
              </div>
            </div>
            <div class="dropdown-divider"  *ngIf="!isFromSSO"></div>
            <a class="dropdown-item" href="javascript:void(0)" (click)="changePassword()" *ngIf="!isFromSSO">
              <i class="fa fa-lock fa-sm fa-fw mr-2 vt-cursor-pointer"></i>
              {{'header.change_password' | translate}}
            </a>
            <div class="dropdown-divider"></div>
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
              <mat-expansion-panel-header>
                <mat-panel-title class="dropdown-item dropdown-item-title">
                  <i class="fa fa-cog fa-sm fa-fw vt-cursor-pointer"></i>
                  {{'header.personal_config.title' | translate}}
                </mat-panel-title>
                <div class="dropdown-divider"></div>
              </mat-expansion-panel-header>
              <div *ngIf="connected2TypesAccounts" class="dropdown-divider"></div>
              <a *ngIf="connected2TypesAccounts" class="dropdown-item" href="javascript:void(0)"
                (click)="changeDefaultVersion()">
                {{'header.personal_config.setting_default_version' | translate}}
              </a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="javascript:void(0)" (click)="changeDigitalCertificate()">
                {{'header.personal_config.method_sign' | translate}}
              </a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="javascript:void(0)" (click)="navigateProcedure()"
                *ngIf="userType == userEnterpriseAdminType || userType == userEnterpriseStaffType">
                {{'header.personal_config.procedure_sign' | translate}}
              </a>
              <div class="dropdown-divider" *ngIf="userType == userEnterpriseAdminType || userType == userEnterpriseStaffType"></div>
              <a class="dropdown-item" href="javascript:void(0)" (click)="navigateLinkGoogleAccount()"
                *ngIf="userType == userEnterpriseAdminType || userType == userEnterpriseStaffType">
                {{'header.personal_config.link_account' | translate}}
              </a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="javascript:void(0)" (click)="configSaveMySignSession();">
                {{'mysign-session-config.mysign-session-config' | translate}}
              </a>
            </mat-expansion-panel>
            <div *ngIf="isShowMenuInfoUseResource" class="dropdown-divider"></div>
            <a *ngIf="isShowMenuInfoUseResource" class="dropdown-item" href="javascript:void(0)" (click)="openPopupUseRecources()">
              <i class="fa fa-info-circle fa-sm fa-fw mr-2 vt-cursor-pointer" aria-hidden="true"></i>
              {{'header.info_use_service' | translate}}
            </a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="javascript:void(0)" (click)="openPopupFeedback()">
              <i class="fa fa-paper-plane fa-sm fa-fw mr-2 vt-cursor-pointer"></i>
              {{'reflection.title.send_feedback' | translate}}
            </a>
            <div class="dropdown-divider"></div>
<!--            <a class="dropdown-item dropdown-item-title" href="https://hopdongdientu.viettel.vn/about/quy-che-hoat-dong"-->
<!--              target="_blank">-->
<!--              <i class="fa fa-question-circle fa-sm fa-fw mr-2 vt-cursor-pointer"></i>-->
<!--              {{'lading_page.footer.footer_column_three.operation_regulation' | translate}}-->
<!--            </a>-->
<!--            <div class="dropdown-divider"  *ngIf="!isFromSSO"></div>-->
            <a class="dropdown-item" href="javascript:void(0)" (click)="logout()" *ngIf="!isFromSSO">
              <i class="fa fa-sign-out fa-sm fa-fw mr-2 vt-cursor-pointer"></i>
              {{'header.logout' | translate}}
            </a>
          </div>
          <div [ngStyle]="{ 'display': showChangeVersion ? 'block': 'none'}" class="menu-setting">
            <div class="top-setting">
              <i class="fa fa-arrow-left fa-sm fa-fw mr-2 vt-cursor-pointer" (click)="swapMenu()"></i>
              <span>{{ 'header.setting_menu' | translate }}</span>
            </div>
            <div class="dropdown-divider"></div>
            <mat-radio-group [(ngModel)]="chooseVersion" (change)="chooseVersionChange()">
              <div class="menu-setting-options mb-3">
                <div class="user-block pr-2">
                  <div class="icon-user mr-2">
                    <i class="fa fa-user-circle-o vt-cursor-pointer" [matTooltip]="userName"></i>
                  </div>
                  <div class="user-infomation">
                    <p class="user-name">{{userName}}</p>
                    <p class="mode v-contract">vContract</p>
                  </div>
                </div>
                <mat-radio-button [value]="1"></mat-radio-button>
              </div>
              <div class="menu-setting-options">
                <div class="user-block">
                  <div class="icon-user mr-2">
                    <i class="fa fa-user-circle-o vt-cursor-pointer" [matTooltip]="userName"></i>
                  </div>
                  <div class="user-infomation">
                    <p class="user-name">{{userName}}</p>
                    <p class="mode s-contract">sContract</p>
                  </div>
                </div>
                <mat-radio-button [value]="2"></mat-radio-button>
              </div>
            </mat-radio-group>
            <div class="dropdown-divider"></div>
          </div>
        </div>
      </li>

      <div class="topbar-divider d-none d-sm-block"></div>
    </ul>

    <div id="sidebar_menu_mobile">
      <app-header-sidebar></app-header-sidebar>
    </div>

  </div>

</nav>
